import { AVATAR_COLORS_INDEX_MAP } from './constants';
export default function getColorByName(name) {
  const nameToNumber = name ? name.split('').map(l => l.charCodeAt(0)).reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;
  return AVATAR_COLORS_INDEX_MAP[nameToNumber % 7];
}
//# sourceMappingURL=getColorByName.js.map